// src/components/Layout/CollapsibleInventoryPanel.js
import React, { useState } from 'react';
import styles from './CollapsibleInventoryPanel.module.css';
import MiniInventoryDisplay from './MiniInventoryDisplay';

const CollapsibleInventoryPanel = ({ playerData, onEquipItem, onUseItem, onSellItem, onToggleItemLock, isItemLocked, onSellAllUnlockedItems, shopContext = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const togglePanel = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      {/* Toggle Tab Button */}
      <button 
        className={`${styles.toggleTab} ${isExpanded ? styles.expanded : ''}`}
        onClick={togglePanel}
        title={isExpanded ? "Close Inventory" : "Open Quick Inventory"}
      >
        <img 
          src="/img/icons/inventoryIcon.png" 
          alt="Inventory" 
          className={styles.tabIcon}
        />
        <span className={styles.tabText}>
          {shopContext ? "Sell" : "Items"}
        </span>
        <span className={`${styles.arrow} ${isExpanded ? styles.open : ''}`}>
          &#9664;
        </span>
      </button>

      {/* Collapsible Panel */}
      <div className={`${styles.inventoryPanel} ${isExpanded ? styles.expanded : ''}`}>
        <MiniInventoryDisplay
          playerData={playerData}
          onEquipItem={onEquipItem}
          onUseItem={onUseItem}
          onSellItem={onSellItem}
          onToggleItemLock={onToggleItemLock}
          isItemLocked={isItemLocked}
          onSellAllUnlockedItems={onSellAllUnlockedItems}
          shopContext={shopContext}
        />
      </div>
    </>
  );
};

export default CollapsibleInventoryPanel; 